/**
 * DetailDate component.
 */
import Container from '@components/atoms/container/detailDateContainer';
import Separator from '@components/atoms/text/detailDateSeparator';
import Text from '@components/atoms/text/detailDateText';
import useDateInfo, { SEP } from '@shared/components/utils/hooks/useDateInfo';
import { Fragment } from 'react';

/**
 * Displays the event date information.
 */
export default function DetailDate() {
  const date = useDateInfo();
  return date?.length ? (
    <Container id='detailDate'>
      {date.map((item, index) => (
        <Fragment key={`${item.key}-${index}`}>
          <Text bold={item.bold}>{item.text}</Text>
          {index < date.length - 1 ? <Separator>{SEP}</Separator> : null}
        </Fragment>
      ))}
    </Container>
  ) : null;
}
